import { render, staticRenderFns } from "./AppointmentSpecials.vue?vue&type=template&id=19118b4b&scoped=true&"
import script from "./AppointmentSpecials.ts?vue&type=script&lang=ts&"
export * from "./AppointmentSpecials.ts?vue&type=script&lang=ts&"
import style0 from "./AppointmentSpecials.scss?vue&type=style&index=0&id=19118b4b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19118b4b",
  null
  
)

export default component.exports